export const name = 'gzTimeRange';
export default function gzTimeRange(
  // Directive angular dependencies
) {
  'ngInject';

  let directive = {
    restrict: 'EA',
    scope: {
      init: '=',
      onChange: '='
    },
    template: require('./time-range.jade'),
    link: timeRangeLink,
    controller: timeRangeController,
    controllerAs: 'vm',
    bindToController: true,
  };
  return directive;

  //////////////////////

  function timeRangeLink(scope, element, attrs) {
  }

  /** @ngInject */
  function timeRangeController(
    // Controller angular dependencies
    moment
  ) {
    // Constants
    const DEFAULT_RETURN_FORMAT = 'YYYY-MM-DD HH:mm:ss';

    // Variables

    // View Model
    let vm = this;
    vm.startTime = null;
    vm.endTime = null;

    //   VM properties
    //   VM methods

    vm.$onInit = onInit;
    vm.timeChanged = timeChanged;
    return;

    ///////////////
    // Init
    function onInit() {
      if (vm.init) {
        
      }
    }

    ///////////////
    // VM methods

    function notifyParent(range) {
      if (vm.onChange) {
        vm.onChange(range);
      }
    }

    function timeChanged() {

      if (!vm.startTime || !vm.endTime) {
        notifyParent(null);
        return;
      }

      let start = moment(vm.startTime);
      let end = moment(vm.endTime);

      let invalid = end.isBefore(start);

      if (invalid) {
        notifyParent(null);
        return;
      }
      else {
        let formatString = vm.timeFormat ? vm.timeFormat : DEFAULT_RETURN_FORMAT;
        let timeRange = {
          start: start.format(formatString),
          end: end.format(formatString)
        };

        notifyParent(timeRange);
      }
    }
  }
}



// WEBPACK FOOTER //
// ../~/@printos/gazelle/src/components/time-range/time-range.directive.js